import { ApolloError } from '@apollo/client';
import { logError } from '@zg-rentals/log-error';
import { getCurrentSessionURL } from './fullStory';

type ErrorContext = Record<string, unknown>;

type AppError = {
  message?: string;
  context?: ErrorContext;
  conversationId?: string;
  error?: any;
};

const isUserAuthError = (err: any) => hasWordInErrorMessage(err, 'user');

const hasWordInErrorMessage = (err: Error, word: string) => {
  if (!err || !err.message) {
    return false;
  }

  const lowercaseMessage = err.message.toLowerCase();
  return lowercaseMessage.indexOf(word) > -1;
};

const formatForLog = (err: any): any => {
  return {
    error: {
      code: err?.code,
      stack: err?.stack,
      message: err?.message,
      data: err?.data,
    },
  };
};

const logAppError = ({ conversationId = '', error = '', context = {}, message = '' }: AppError): void => {
  if (isUserAuthError(error)) {
    return;
  }

  const formattedError = formatForLog(error);
  const fullStorySessionUrl = getCurrentSessionURL();

  logError({ error, context: { conversationId, formattedError, message, fullStorySessionUrl, ...context } });
};

const logApolloError = (error: ApolloError, context: Record<string, unknown>) => {
  const fullStorySessionUrl = getCurrentSessionURL();
  // Apollo errors do not have a custom name; explicitly tag Marlin events with "ApolloError"
  logError({ error, context: { ...context, fullStorySessionUrl }, errorType: 'ApolloError' });
};

export { isUserAuthError, logApolloError, logAppError };
